import { Container } from "./Loader.styles";

const Loader = () => {
    return (
        <Container>
            <div>
                <img src="/icon.svg" alt="" />
                <img src="/loader.svg" alt="" />
            </div>
        </Container>
    )
    
};

export default Loader;